import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "./assets/css/default.css";
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import VueGtag from "vue-gtag-next";

import mitt from "mitt";
const emitter = mitt();

import Maska from "maska";
import { VueReCaptcha } from "vue-recaptcha-v3";

declare module "@vue/runtime-core" {
  interface ComponentCustomProperties {
    $emitter: Record<string, unknown>;
  }
}
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

const app = createApp(App)
  .use(pinia)
  .use(router)
  .use(Maska)
  .provide("$emitter", emitter)
  .use(VueReCaptcha, {
    siteKey: process.env.VUE_APP_CAPTCHA_KEY,
    loaderOptions: {
      useRecaptchaNet: true,
    },
  })
  .use(VueGtag, {
    property: {
      id: process.env.VUE_APP_GA_ID,
    },
  });

//app.config.errorHandler = (err, vm, info) => {
// handle error
//  `info` is a Vue-specific error info, e.g. which lifecycle hook
//  the error was found in
//  console.log("Vue load error: %o", err);
//};
app.mount("#app");
